class Menu

  constructor: ->
    @$wrapper = $('.ch-pages-wrapper').hide()
    @$gnavi = $('.ch-gnav-wrapper')

    $('.ch-gnav li a').on 'click', (event) =>
      event.preventDefault()
      @$gnavi.addClass('is-open')
      @$wrapper.slideToggle(300)

    @$wrapper.on 'mouseleave', =>
      @$wrapper.slideToggle 0
      @$gnavi.removeClass('is-open')

    $('.ch-pages-inner .ch-pages-box').on
      'mouseenter': ->
        index = $('.ch-pages-inner .ch-pages-box').index(this)
        $('.ch-gnav li').eq(index).addClass('js-ch-active')
      'mouseleave': ->
        $('.ch-gnav li').removeClass('js-ch-active')

export default Menu



// WEBPACK FOOTER //
// ./webpack/imports/view/menu.coffee